import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";

const FloatingMenu = ({ anchorRef, onClose, children, id }) => {
	const menuRef = useRef(null);
	const [position, setPosition] = useState({ top: 0, left: 0 });

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				menuRef.current &&
				!menuRef.current.contains(event.target) &&
				anchorRef.current &&
				!anchorRef.current.contains(event.target)
			) {
				onClose();
			}
		};

		const calculatePosition = () => {
			const anchorRect = anchorRef.current?.getBoundingClientRect() || null;
			const menuHeight = menuRef.current?.offsetHeight || 150;
			const spaceBelow = window.innerHeight - anchorRect?.bottom || 0;

			const top =
				spaceBelow < menuHeight
					? (anchorRect?.top || 0) - menuHeight
					: (anchorRect?.bottom || 0);
			const left = anchorRect?.left || 0;

			setPosition({ top, left });
		};

		calculatePosition();
		document.addEventListener("click", handleClickOutside);
		window.addEventListener("resize", calculatePosition);
		window.addEventListener("scroll", calculatePosition, true);

		return () => {
			document.removeEventListener("click", handleClickOutside);
			window.removeEventListener("resize", calculatePosition);
			window.removeEventListener("scroll", calculatePosition, true);
		};
	}, [anchorRef, onClose]);

	// ✨ Esta función aplana fragments
	const flattenChildren = (children) => {
		return React.Children.toArray(children).flatMap((child) => {
			if (child.type === React.Fragment) {
				return flattenChildren(child.props.children);
			}
			return child;
		});
	};

	return ReactDOM.createPortal(
		<ul
			ref={menuRef}
			className="dropdown__container"
			style={{
				position: "fixed",
				top: `${position.top}px`,
				left: `${position.left}px`,
				zIndex: 9999,
			}}
		>
			{flattenChildren(children).map((child) => {
				if (!React.isValidElement(child)) return null;

				const originalOnClick = child.props.onClick;
				const enhancedOnClick = (e) => {
					if (originalOnClick) originalOnClick(e);
					onClose();
				};

				return React.cloneElement(child, {
					onClick: enhancedOnClick,
				});
			})}
		</ul>,
		document.body
	);
};

export default FloatingMenu;
